const initialState = { btnLoaderOne: false, adminView: 'customer', orderActiveStep: 0 };

export function AppReducers(state = initialState, action) {
  switch (action?.type) {
    case 'BTN_LOADER_ONE':
      return {
        ...state,
        btnLoaderOne: action.payload,
      };
    case 'STORE_REGISTRATION_FORM':
      return {
        ...state,
        registrationForm: action.payload,
      };
    case 'SAVE_ADMIN_VIEW':
      return {
        ...state,
        adminView: action.payload,
      };
    case 'SAVE_BILLING_VALUES':
      return {
        ...state,
        billingValues: action.payload,
      };
    case 'SAVE_ACTIVE_STEP':
      return {
        ...state,
        orderActiveStep: action.payload,
      };

    default:
      return state;
  }
}
